export const DEFAULT_ROUTE = '/radio/objects';
